module.exports = __webpack_public_path__ + "static/media/log-out-blue.9a36e896.svg";